import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "most-obvious-signs-your-flat-foam-roof-needs-a-recoat-in-phoenix";
export const Route = createFileRoute("/most-obvious-signs-your-flat-foam-roof-needs-a-recoat-in-phoenix")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
